module.exports = __webpack_public_path__ + "img/header-diamondJewelrySignet@2x.2252b97.webp";